import Blockquote from '../../../components/Blockquote/Blockquote'

export default function Quote (props = {
    text: null,
    caption: null,
    img: {
        src: null,
        alt: null,
        width: null,
        height: null
    }
}) {
    if (!props.text && !props.children)
        return null

    const text = props.children || props.text

    return (
        <div className="quote pad-section">
            <div className="container">
                <div className="row flex-justify-content-center">
                    <div className="col-12 col-9-md col-8-lg-up">
                        <Blockquote
                            text={text}
                            caption={props.caption}
                            img={props.img}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
